"use strict";
var mat4_1 = require('./utils/mat4');
var vec3 = require('gl-matrix/src/gl-matrix/vec3');
var mat4 = require('gl-matrix/src/gl-matrix/mat4');
var quat = require('gl-matrix/src/gl-matrix/quat');
var px = vec3.fromValues(1, 0, 0);
var py = vec3.fromValues(0, 1, 0);
var pz = vec3.fromValues(0, 0, 1);
var temp1 = vec3.create();
var Object3D = (function () {
    function Object3D(vao, shaderType, size) {
        this.position = vec3.create();
        this.quaternion = quat.create();
        this.scale = vec3.fromValues(1, 1, 1);
        this.modelMatrix = mat4.create();
        this._modelMatrix = mat4.create();
        this.modelMatrixNeedsUpdate = true;
        this.parent = null;
        this.children = [];
        this.shaderType = shaderType;
        this.vao = vao;
        if (size) {
            this.size = vec3.clone(size);
            this.offset = vec3.fromValues(-this.size[0] / 2, -this.size[1] / 2, -this.size[2] / 2);
        }
        else {
            this.offset = vec3.create();
        }
    }
    Object3D.prototype.setPosition = function (x, y, z) {
        vec3.set(this.position, x, y, z);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    Object3D.prototype.copyPosition = function (p) {
        vec3.copy(this.position, p);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    Object3D.prototype.addPosition = function (p) {
        vec3.add(this.position, this.position, p);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    // translate object by distance along axis in object space
    // axis is assumed to be normalized
    Object3D.prototype.translateOnAxis = function (axis, distance) {
        vec3.copy(temp1, axis);
        vec3.transformQuat(temp1, temp1, this.quaternion);
        vec3.scaleAndAdd(this.position, this.position, temp1, distance);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    ;
    Object3D.prototype.translateX = function (distance) {
        return this.translateOnAxis(px, distance);
    };
    Object3D.prototype.translateY = function (distance) {
        return this.translateOnAxis(py, distance);
    };
    Object3D.prototype.translateZ = function (distance) {
        return this.translateOnAxis(pz, distance);
    };
    Object3D.prototype.setScale = function (x, y, z) {
        vec3.set(this.scale, x, y, z);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    Object3D.prototype.rotateX = function (rad) {
        quat.rotateX(this.quaternion, this.quaternion, rad);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    Object3D.prototype.rotateY = function (rad) {
        quat.rotateY(this.quaternion, this.quaternion, rad);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    Object3D.prototype.rotateZ = function (rad) {
        quat.rotateZ(this.quaternion, this.quaternion, rad);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    Object3D.prototype.lookAt = function (target, up) {
        if (up === void 0) { up = Object3D.defaultUp; }
        mat4_1.lookAt(this.modelMatrix, target, this.position, up);
        mat4.getRotation(this.quaternion, this.modelMatrix);
        this.modelMatrixNeedsUpdate = true;
        return this;
    };
    Object3D.prototype.add = function (object) {
        var index = this.children.indexOf(object);
        if (index === -1) {
            this.children.push(object);
            object.parent = this;
            object.modelMatrixNeedsUpdate = true;
        }
    };
    Object3D.prototype.remove = function (object) {
        var index = this.children.indexOf(object);
        if (index !== -1) {
            this.children.splice(index, 1);
            object.parent = null;
            object.modelMatrixNeedsUpdate = true;
        }
    };
    Object3D.prototype.updateModelMatrix = function (forced) {
        if (forced === void 0) { forced = false; }
        var updated = forced || this.modelMatrixNeedsUpdate;
        if (updated) {
            mat4.fromRotationTranslationScale(this.modelMatrix, this.quaternion, this.position, this.scale);
            if (this.parent)
                mat4.multiply(this.modelMatrix, this.parent.modelMatrix, this.modelMatrix);
            mat4.fromTranslation(this._modelMatrix, this.offset);
            mat4.multiply(this._modelMatrix, this.modelMatrix, this._modelMatrix);
            this.modelMatrixNeedsUpdate = false;
        }
        return updated;
    };
    Object3D.prototype.updateModelMatrixRecursively = function (forced) {
        if (forced === void 0) { forced = false; }
        var updated = this.updateModelMatrix(forced);
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var child = _a[_i];
            child.updateModelMatrixRecursively(updated);
        }
        return updated;
    };
    Object3D.prototype.getDirection = function (out) {
        out[0] = this.modelMatrix[8];
        out[1] = this.modelMatrix[9];
        out[2] = this.modelMatrix[10];
        return out;
    };
    Object3D.prototype.getYaw = function () {
        return Math.atan2(-this.modelMatrix[10], this.modelMatrix[8]);
    };
    Object3D.defaultUp = py;
    return Object3D;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Object3D;
//# sourceMappingURL=Object3D.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/Object3D.js
 ** module id = 334
 ** module chunks = 0
 **/